import React from 'react'

const Logo = () => {
  return (
    <div className='logo'>
      <h1>PING</h1>
    </div>
  )
}

export default Logo
